var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiskey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "w1",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d49a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c87f4f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 18,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 8,
    width: 36,
    height: 120,
    rx: 8,
    fill: "url(#w1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: -4,
    width: 16,
    height: 18,
    rx: 4,
    fill: "#3b2b25"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 136,
    rx: 24,
    ry: 6,
    fill: "#000",
    opacity: 0.06
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiskey);
export default __webpack_public_path__ + "static/media/whiskey.7500352696609895b6394f7a254ece1d.svg";
export { ForwardRef as ReactComponent };